module.exports = __webpack_public_path__ + "img/weather.f3353957.svg";